module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "play"
  }, [_c('drag', [_c('div', {
    staticClass: "work",
    attrs: {
      "slot": "uLeft"
    },
    on: {
      "click": _vm.chooseScreenLeft
    },
    slot: "uLeft"
  }, [_c('k-header', {
    class: {
      negScreen: !_vm.negScreen
    },
    attrs: {
      "headerData": _vm.headerTeacher
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "editor-wrap"
  }, [_c('editor', {
    ref: "teacherEditor",
    attrs: {
      "options": _vm.editorConfig
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "work",
    attrs: {
      "slot": "dLeft"
    },
    on: {
      "click": _vm.chooseScreenLeft
    },
    slot: "dLeft"
  }, [_c('iterm', {
    class: {
      negScreen: !_vm.negScreen
    },
    attrs: {
      "isCompile": "1",
      "options": _vm.itermPlay,
      "tab": _vm.tab,
      "inputParam": _vm.inputParam,
      "compileInfo": _vm.compileInfo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "work bdl",
    attrs: {
      "slot": "uRight"
    },
    on: {
      "click": _vm.chooseScreenRight
    },
    slot: "uRight"
  }, [_c('k-header', {
    class: {
      negScreen: _vm.negScreen
    },
    attrs: {
      "headerData": _vm.headerStudent
    }
  }, [_c('span', {
    staticClass: "live-btn",
    on: {
      "click": _vm.issueQA
    }
  }, [_vm._v("提问")]), _vm._v(" "), _c('span', {
    staticClass: "live-btn t-clear",
    on: {
      "click": _vm.clearCode
    }
  }, [_vm._v("清除代码")]), _vm._v(" "), _c('span', {
    staticClass: "live-btn t-clear",
    on: {
      "click": _vm.exportCode
    }
  }, [_vm._v("导出代码")])]), _vm._v(" "), _c('div', {
    staticClass: "editor-wrap"
  }, [_c('editor', {
    ref: "studentEditor"
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "work bdl",
    attrs: {
      "slot": "dRight"
    },
    on: {
      "click": _vm.chooseScreenRight
    },
    slot: "dRight"
  }, [_c('iterm', {
    class: {
      negScreen: _vm.negScreen
    },
    attrs: {
      "isCompile": "1",
      "options": _vm.itermData,
      "tab": _vm.tab,
      "inputParam": _vm.inputParam,
      "compileInfo": _vm.compileInfo
    },
    on: {
      "insertTemplate": _vm.insertData
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6000b537","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/play/play.vue
// module id = 515
// module chunks = 1